import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: index,
  },
  {
    path: "/toApply",
    name: "toApply",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/toApply/index.vue"),
  },
  {
    path: "/toEnter",
    name: "toEnter",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/toEnter/index.vue"),
  },
  {
    path: "/access",
    name: "access",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/access/index.vue"),
  },
  {
    path: "/file",
    name: "file",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/file/index.vue"),
  },
  {
    path: "/info",
    name: "info",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/info/index.vue"),
  },
  {
    path: "/survey", // 尽职调查
    name: "survey",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/survey/index.vue"),
  },
  {
    path: "/enter", // 尽职调查录入
    name: "enter",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/enter/index.vue"),
  },
  {
    path: "/add", // 尽职调查录入
    name: "add",
    component: () =>
      import(/* webpackChunkName: "/index" */ "../views/enter/correlation/add.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
